<template>
    <div class="subtopic-shortcuts">
        <img src="../assets/icons/half-circle.svg" alt="background" class="circle-bg" />
        <div class="title">Na skróty:</div>
        <scrollactive
            :duration="800"
            bezier-easing-value=".5,0,.35,1"
            :offset="30"
            :modify-url="true"
            :scroll-on-start="true"
            active-class="active"
            class="shortcuts-container"
        >
            <a
                class="scrollactive-item btn shortcut"
                v-for="subtopic in availableSubtopics"
                v-bind:key="subtopic.order"
                :href="'#' + subtopic.id"
            >
                <div class="shortcut__icon-circle">
                    <AssetsImg :asset-path="subtopic.iconPath" alt="subtopic icon" />
                </div>
                <div class="shortcut__label">
                    {{ subtopic.title }}
                </div>
            </a>
        </scrollactive>
    </div>
</template>

<script>
    import AssetsImg from '@/components/AssetsImg';
    import { subtopics } from '@/model/topics-data';

    export default {
        name: 'SubtopicShortcuts',
        components: { AssetsImg },
        props: {
            topic: Object,
        },
        data: function () {
            return {
                subtopics: subtopics,
            };
        },
        computed: {
            availableSubtopics: function () {
                let availableSubtopics = [];
                for (const subtopic of subtopics) {
                    if (this.topic[subtopic.id].length > 0) {
                        availableSubtopics.push(subtopic);
                    }
                }
                return availableSubtopics;
            },
        },
        methods: {
            onItemChanged(event, currentItem, lastActiveItem) {
                console.log(event, currentItem, lastActiveItem);
            },
        },
    };
</script>

<style lang="scss">
    .subtopic-shortcuts {
        position: relative;
        background: $green;
        padding-bottom: 94px;

        .title {
            font-weight: bold;
            margin-bottom: 30px;
            color: $white;
            z-index: 10;
        }

        .circle-bg {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            z-index: 0;
        }

        .shortcuts-container {
            max-width: 375px;
            margin-left: auto;
            margin-right: auto;
            display: flex;
            flex-flow: row wrap;
            justify-content: center;

            a {
                text-decoration: none;
                color: $green;
                -webkit-tap-highlight-color: transparent;
            }

            .shortcut {
                position: relative;
                width: 148px;
                height: 50px;
                border-radius: 30px;
                background-color: $white;
                margin-bottom: 20px;

                &:nth-child(odd) {
                    margin-right: 10px;
                }

                &:nth-child(even) {
                    margin-left: 10px;
                }

                &:nth-child(odd):last-child {
                    margin-right: 0;
                }

                @media screen and (max-width: 374px) {
                    width: 128px;
                }

                &__icon-circle {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 50px;
                    height: 50px;
                    border-radius: 30px;
                    background-color: $gold;
                }

                &__label {
                    text-align: left;
                    line-height: 50px;
                    font-size: 15px;
                    font-weight: 600;
                    padding-left: 60px;
                    padding-right: 10px;

                    @media screen and (max-width: 374px) {
                        padding-left: 55px;
                        font-size: 13px;
                    }
                }
            }
        }
    }
</style>
